export const APP_TITLE = '思无崖AI内容信息后台管理系统'
export const APP_VERSION = '0.1.0'
